import { h, render } from "preact";
import { useEffect, useState, useRef } from "preact/hooks";

const ProductInterstitial = ({ data }) => {
  const content = data;
  if (!content) return;

  const color = content?.content_color || "white";

  return (
    <div
      className={`product-interstitial product-interstitial__${content?.block_id} fade`}
    >
      <style>
        {`.product-interstitial__${content?.block_id} {
          --position-mobile: ${content?.position_mobile};
          --position-desktop: ${content?.position_desktop};
          --offset-tablet-wide: ${
            content?.alignment_desktop == "right" ? 2 : 1
          };
          --offset-desktop: ${
            content?.alignment_desktop == "right" ? 3 : 1
          } };`}
      </style>
      <div className="product-interstitial__container">
        {content?.badge_copy != "" && (
          <p className="product-interstitial__badge fade">
            {content?.badge_copy}
          </p>
        )}
        <div className="product-interstitial__background">
          {content?.image_desktop && (
            <picture>
              <source
                media="(min-width: 1920px)"
                srcset={getSizedImageUrl(content?.image_desktop, "1400x")}
              />
              <source
                media="(min-width: 1440px)"
                srcset={getSizedImageUrl(content?.image_desktop, "1200x")}
              />
              <source
                media="(min-width: 1280px)"
                srcset={getSizedImageUrl(content?.image_desktop, "1000x")}
              />
              <source
                media="(min-width: 768px)"
                srcset={getSizedImageUrl(content?.image_desktop, "800x")}
              />
              {content?.image_mobile && (
                <img
                  alt="Collection Demo"
                  src={getSizedImageUrl(content?.image_mobile, "600x")}
                />
              )}
            </picture>
          )}
          {content?.cta_url_1 && (
            <a
              href={content?.cta_url_1}
              className="product-interstitial__link"
              aria-label={content?.heading}
            ></a>
          )}
        </div>

        <div className="product-interstitial__inner">
          <div className={`product-interstitial__content color-${color}`}>
            <h2
              className="fade"
              dangerouslySetInnerHTML={{
                __html: content?.heading?.replace(/<\/?p[^>]*>/g, ""),
              }}
            ></h2>

            <p className="product-interstitial__copy fade">{content?.copy}</p>

            <div className="product-interstitial__cta-container">
              {content?.cta_url_1 && content?.cta_copy_1 && (
                <a
                  href={content?.cta_url_1}
                  className={`product-interstitial__cta button button--${
                    color === "white" ? "outline" : "outline-secondary"
                  }`}
                >
                  {content?.cta_copy_1}
                </a>
              )}

              {content?.cta_url_2 && content?.cta_copy_2 && (
                <a
                  href={content?.cta_url_2}
                  className={`product-interstitial__cta button button--${
                    color === "white" ? "primary" : "black"
                  }`}
                >
                  {content?.cta_copy_2}
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductInterstitial;
